/*
 * --------------------------------------------------------------------------
 *   Geneseed Template: Version 2.0
 *   Author: PFS
 *   Created: 9/15/2022  
 * --------------------------------------------------------------------------
*/

/*
* ------------------------------------------------------------------------
* Bootstrap 5
* Source code and more for the most popular front-end framework in the world
* https://github.com/twbs
* ------------------------------------------------------------------------
*/   
import '../scss/index.scss';  
import * as bootstrap from '../../node_modules/bootstrap/dist/js/bootstrap.bundle';
 
/*
* ------------------------------------------------------------------------
* Modernizr
* Tells you what HTML, CSS and JavaScript features the user’s browser has to offer
* https://modernizr.com/
* ------------------------------------------------------------------------
*/   
import './components/modernizr.min'; 
 
/*
* ------------------------------------------------------------------------
* Anime
* A lightweight JavaScript animation library
* https://github.com/juliangarnier/anime/
* ------------------------------------------------------------------------
*/  
import anime from 'animejs/lib/anime.es.js';

/*
* ------------------------------------------------------------------------
* Scrollama 
* Runs to create a substring nav link to go back to regular menu pages
* https://github.com/russellsamora/scrollama
* ------------------------------------------------------------------------
*/   
import scrollama from "scrollama"; 
 
/*
* ------------------------------------------------------------------------
* Rellax 
* Lightweight, vanilla javascript parallax library
* https://github.com/dixonandmoe/rellax
* ------------------------------------------------------------------------
*/ 
import Rellax from 'rellax';  

// EXPORT MODULES
export default {
	bootstrap, 
	anime,
	scrollama,  
	Rellax,  
};
 

//**===== [ GLOBAL VARIABLES] =====**//
// return base of site url <-- http://example.com
var baseUrl = window.location.origin;

// return site url <-- example.com
var hostUrl = window.location.host;
 

//**===== [ GLOBAL FUNCTIONS] =====**//
/*
 * ------------------------------------------------------------------------
 * Select Item Function
 * Select current item by clearing any with previous current classes
 * ------------------------------------------------------------------------
*/
let selectItem = function(item) {
	// refresh style state
	if(item.classList.contains(item)) {
		item.classList.remove(item)
	}  
	// remove other selected items
	document.querySelectorAll(item).forEach(e => e.classList.remove(item));
	// add selected class to current item
	item.classList.add(item);  
}
 
var isVariableDefined = function (el) {
	return typeof !!el && el != 'undefined' && el != null;
}

var getParents = function (el, selector, filter) {
	const result = [];
	const matchesSelector = el.matches || el.webkitMatchesSelector || el.mozMatchesSelector || el.msMatchesSelector;

	// match start from parent
	el = el.parentElement;
	while (el && !matchesSelector.call(el, selector)) {
		if (!filter) {
			if (selector) {
				if (matchesSelector.call(el, selector)) {
					return result.push(el);
				}
			} else {
				result.push(el);
			}
		} else {
			if (matchesSelector.call(el, filter)) {
				result.push(el);
			}
		}
		el = el.parentElement;
		if (e.isVariableDefined(el)) {
			if (matchesSelector.call(el, selector)) {
				return el;
			}
		}
	}
	return result;
}

var getNextSiblings = function (el, selector, filter) {
	let sibs = [];
	let nextElem = el.parentNode.firstChild;
	const matchesSelector = el.matches || el.webkitMatchesSelector || el.mozMatchesSelector || el.msMatchesSelector;
	do {
		if (nextElem.nodeType === 3) continue; // ignore text nodes
		if (nextElem === el) continue; // ignore elem of target
		if (nextElem === el.nextElementSibling) {
			if (!filter || filter(el)) {
				if (selector) {
					if (matchesSelector.call(nextElem, selector)) {
						return nextElem;
					}
				} else {
					sibs.push(nextElem);
				}
				el = nextElem;
			}
		}
	} while ((nextElem = nextElem.nextSibling));
	return sibs;
}

var on = function (selectors, type, listener) {
	document.addEventListener('DOMContentLoaded', () => {
		if (!(selectors instanceof HTMLElement) && selectors !== null) {
			selectors = document.querySelector(selectors);
		}
		selectors.addEventListener(type, listener);
	});
}

var onAll = function (selectors, type, listener) {
	document.addEventListener('DOMContentLoaded', () => {
		document.querySelectorAll(selectors).forEach((element) => {
			if (type.indexOf(',') > -1) {
				let types = type.split(',');
				types.forEach((type) => {
					element.addEventListener(type, listener);
				});
			} else {
				element.addEventListener(type, listener);
			}
		});
	});
}

var removeClass = function (selectors, className) {
	if (!(selectors instanceof HTMLElement) && selectors !== null) {
		selectors = document.querySelector(selectors);
	}
	if (e.isVariableDefined(selectors)) {
		selectors.removeClass(className);
	}
}

var removeAllClass = function (selectors, className) {
	if (e.isVariableDefined(selectors) && selectors instanceof HTMLElement) {
		document.querySelectorAll(selectors).forEach((element) => {
			element.removeClass(className);
		});
	}
}

var toggleClass = function (selectors, className) {
	if (!(selectors instanceof HTMLElement) && selectors !== null) {
		selectors = document.querySelector(selectors);
	}
	if (e.isVariableDefined(selectors)) {
		selectors.toggleClass(className);
	}
}

var toggleAllClass = function (selectors, className) {
	if (e.isVariableDefined(selectors) && selectors instanceof HTMLElement) {
		document.querySelectorAll(selectors).forEach((element) => {
			element.toggleClass(className);
		});
	}
}

var addClass = function (selectors, className) {
	if (!(selectors instanceof HTMLElement) && selectors !== null) {
		selectors = document.querySelector(selectors);
	}
	if (e.isVariableDefined(selectors)) {
		selectors.addClass(className);
	}
}

var select = function (selectors) {
	return document.querySelector(selectors);
}

var selectAll = function (selectors) {
	return document.querySelectorAll(selectors);
} 

/*
 * ------------------------------------------------------------------------
 * Run On Exit Function
 * Runs when page exits before loading new page. Use for clearing
 * listeners or anything needing deleted.
 * ------------------------------------------------------------------------
*/
var runOnExit = function () {
	console.log(':: Page Cleared ::');
}
 
/* 
* ------------------------------------------------------------------------
* THEME FUNCTIONS 
* ------------------------------------------------------------------------
*/  
var e = {
	init: function () {  
		e.backToTop(), 
		e.changeNavLinks(),
		// e.cookieNoticePopup(),
		e.contactFormRedirect(),
		e.heroBackgroundImgResize(),
		e.heroKenBurnImgResize(), 
		e.initializePopOvers(),
		e.mobileFeatures(),
		e.pixelForgeStudioGlow(),
		e.positionScrollspyNav(),
		e.rippleEffect(),
		e.scrollama(),
		e.showCurrentPageStatus(),
		e.sidebarNavProgress(), 
		e.toggleMenu(),     
		e.triforceAjaxLoader(), 
		e.wooCommerce(),
		e.contactFormBtn(),  
		e.animeTitleEffect(),     
		e.animeHeroEffect(), 
		e.jumpToHashTagLink(),
		e.rellaxSection(); 
	},  

	/* 
	* ------------------------------------------------------------------------
	* Button Back-To-Top  
	* Runs when the viewport scrolls down
	* ------------------------------------------------------------------------
	*/  
	backToTop: function () {
		var scrollpos = window.scrollY; 
		if(select('.back-top')) { 
			var backBtn = select('.back-top');

			if (isVariableDefined(backBtn)) {
				var add_class_on_scroll = () => backBtn.classList.add('back-top-show');
				var remove_class_on_scroll = () => backBtn.classList.remove('back-top-show');
	
				window.addEventListener('scroll', function () {
					scrollpos = window.scrollY;
					if (scrollpos >= 800) {
						add_class_on_scroll();
					} else {
						remove_class_on_scroll();
					}
				});
	
				backBtn.addEventListener('click', () =>
					window.scrollTo({
						top: 0,
						behavior: 'smooth',
					})
				);
			}
		} 
	},  

	/*
	* ------------------------------------------------------------------------
	* Change Nav Links
	* Runs to create a substring nav link to go back to regular menu pages
	* ------------------------------------------------------------------------
	*/    
	changeNavLinks: function () {  
		if (document.querySelector(".a-social-contract-page") || document.querySelector(".a-mint-page")) { 
			// console.log(":: Page Activated ::");
			var navItems = document.querySelectorAll('.nav-link'); // get all nav links 

			// change url on each click
			navItems.forEach((item) => {  

				item.addEventListener('click', (event) => {
					// console.log('event: ', event);  
					var str = window.location.href; // get current URL string 
					var lastUrlString = str.substring(str.lastIndexOf("/") + 1, str.length); // get last substring of URL
					window.location.href = baseUrl + lastUrlString + item.hash;    
				}); 
			});
 
			// clear event listeners
			runOnExit = function() {
				navItems.removeEventListener('click'); 
			}
		}  
	},

	/*
	* ------------------------------------------------------------------------
	* Cookie Notice
	* Runs to create a cookie notice at the bottom
	* ------------------------------------------------------------------------
	*/     
	// cookieNoticePopup: function () {
	// 	//<![CDATA[ 
	// 	var _tppCookieTitle = '<h6 class="m-0 pe-3 text-primary"><i class="fa-duotone fa-cookie-bite"></i> Cookie Consent</h6>';
	// 	var _tppCookieMessage = '<p class="m-0 pe-3">This website use cookies to help you have a superior and more relevant browsing experience on the website. <a class="inner-link-effect" href="/privacy-policy">Read More</a></p>';

	// 	var _tppButtonTitle = "Accept";

	// 	var _tppCookieForDays = 300;

	// 	if (!getCookie("cookieConsentAccepted")) {
	// 		var cookHtml = '<div id="cookie-law-info-bar" class="alert alert-light alert-dismissible fade show position-fixed bottom-0 start-50 translate-middle-x z-index-99 d-lg-flex justify-content-between align-items-center shadow p-4 col-9 col-md-5"><div class="d=flex flex-column">' + _tppCookieTitle + _tppCookieMessage + '</div><div class="d-flex mt-3 mt-lg-0"><button id="acceptCookie" class="btn-cookie-accept btn btn-sm mb-0 me-2">' + _tppButtonTitle + "</button>&nbsp;&nbsp;&nbsp; </div></div>";

	// 		var _cdiv = document.createElement("div");

	// 		_cdiv.id = "_cookieMessageDiv";

	// 		document.body.appendChild(_cdiv);

	// 		var _divTag = document.getElementById("_cookieMessageDiv");

	// 		_divTag.innerHTML += cookHtml;
	// 	}

	// 	function setCookie(e, o, t) {
	// 		var n = new Date();
	// 		n.setTime(n.getTime() + 24 * t * 60 * 60 * 1e3);
	// 		var i = "expires=" + n.toUTCString();
	// 		document.cookie = e + "=" + o + ";path=/; " + i;
	// 	}

	// 	function getCookie(e) {
	// 		for (var o = e + "=", t = document.cookie.split(";"), n = 0; n < t.length; n++) {
	// 			for (var i = t[n]; " " == i.charAt(0); ) i = i.substring(1);
	// 			if (0 == i.indexOf(o)) return i.substring(o.length, i.length);
	// 		}
	// 		return "";
	// 	}

	// 	var e = document.getElementById("acceptCookie");

	// 	e &&
	// 		e.addEventListener("click", function () {
	// 			setCookie("cookieConsentAccepted", "YES", _tppCookieForDays), document.getElementById("cookie-law-info-bar").remove();
	// 		});

	// 	//]]>
	// },

	/*
	* ------------------------------------------------------------------------
	* Contact Form Redirect
	* Runs to redirect user to another page after contact form submission
	* ------------------------------------------------------------------------
	*/  
	contactFormRedirect: function () { 
		if(document.querySelector('.wpcf7mailsent')) {
			document.addEventListener('wpcf7mailsent', function (event) {
				if ('208' === event.detail.contactFormId) { 
					// location = 'https://www/[url here]/';
				}
			}, false); 
		} 
	}, 

	/*
	* ------------------------------------------------------------------------
	* Hero Background Image Resize
	* Runs window resize to maintain height  
	* ------------------------------------------------------------------------
	*/ 
	heroBackgroundImgResize: function () { 
		if(document.querySelector('.a-hero-blog')) {
			heroImageBgResize();

			// Resize based on mobile orientation
			window.addEventListener("resize", heroImageBgResize);
			  
			function heroImageBgResize() {
				let heroKenburnContainer = document.querySelector('.a-hero-blog');    
				let heroKenburnImg = document.querySelector('.a-hero-content');

				let heroImageHeight = heroKenburnImg.offsetHeight;   
				heroKenburnContainer.style.height = heroKenburnImg.offsetTop + heroImageHeight + 150 +  'px';  
			}
		} 
	},

	/*
	* ------------------------------------------------------------------------
	* Hero Background Image Resize
	* Runs window resize to maintain height  
	* ------------------------------------------------------------------------
	*/ 
	heroKenBurnImgResize: function () { 
		if(document.querySelector('.a-hero-blogx')) {
			heroKenBurnResize();

			// Resize based on mobile orientation
			window.addEventListener("resize", heroKenBurnResize);
			  
			function heroKenBurnResize() {
				let heroAnimeContainer = document.querySelector('.a-hero-blog');    
				let heroContent = document.querySelector('.kenburn-img');

				let heroImageHeight = heroContent.offsetHeight;   
				heroAnimeContainer.style.height = heroContent.offsetTop + heroImageHeight + 'px';  
			}
		} 
	}, 
 
	/*
	* ------------------------------------------------------------------------
	* Initialize Popovers
	* Runs to initialize popovers
	* ------------------------------------------------------------------------
	*/  
	initializePopOvers: function () {
		if(document.querySelectorAll('[data-bs-toggle="popover"]')) {
			var popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'))
			var popoverList = popoverTriggerList.map(function (popoverTriggerEl) {
				return new bootstrap.Popover(popoverTriggerEl)
			});
		} 
	},

	/*
	* ------------------------------------------------------------------------
	* Mobile UI Features
	* Runs only for mobile viewport
	* ------------------------------------------------------------------------
	*/   
	mobileFeatures: function () {
		if (navigator.userAgent.match(/Android/i) || navigator.userAgent.match(/webOS/i) || navigator.userAgent.match(/iPhone/i) || navigator.userAgent.match(/iPod/i) || navigator.userAgent.match(/BlackBerry/i) || navigator.userAgent.match(/Windows Phone/i)) {

			// Target element here

			// Apply styles
			if (document.querySelector('.example-code')) { 

				function mobileResizeArea() {
					if (window.innerWidth <= 450) {
						// Target for vertical 
					} else if (window.innerWidth > 450) {
						// Target for horizontal 
					}
				}

				// Resize based on mobile orientation
				window.addEventListener("resize", mobileResizeArea);
				mobileResizeArea();
			}
		}
	},

	/* 
	* ------------------------------------------------------------------------
	* Pixel Forge Studio Glow 
	* Creates a glow effect for the PFS logo
	* ------------------------------------------------------------------------
	*/   
	pixelForgeStudioGlow: function () { 
		if(document.querySelector('.pfs-pixel')) {
			// Hover container
			anime({
				targets: '.pfs-pixel',
				duration: 1500,
				translateY: -20,
				direction: 'alternate',
				loop: true,
				easing: 'easeInOutSine',
			});

			// Glow background
			anime({
				targets: '.pfs-pixel__glow',
				offset: '-=1000',
				scale: 1.3,
				easing: 'easeInOutSine',
			});
		} 
	}, 
		
	/*
	* ------------------------------------------------------------------------
	* Position Scrollspy Nav
	* Toggles between fixed and absolute positions
	* ------------------------------------------------------------------------
	*/
	positionScrollspyNav: function() {   
		if(document.querySelector('#scrollspy-navbar')) { 
			var scrollspyNavbar = document.querySelector('#scrollspy-navbar');
			var footer = document.querySelector('#footer');

			function checkOffset() { 
				// Return information about size of an element
				function getRectTop(element){
					var rect = element.getBoundingClientRect();
					return rect.top;
				}
				
				if((getRectTop(scrollspyNavbar) + document.body.scrollTop) + scrollspyNavbar.offsetHeight >= (getRectTop(footer) + document.body.scrollTop) - 10) {
					scrollspyNavbar.style.position = 'absolute';
					// console.log(':: Position absolute ::');
				} 
				if(document.body.scrollTop + window.innerHeight < (getRectTop(footer) + document.body.scrollTop)) {
					scrollspyNavbar.style.position = 'fixed'; // Restore when you scroll up
					// console.log(':: Position fixed ::');
				}  
			}

			document.addEventListener("scroll", function(){
				checkOffset();
			});
		} 
	}, 

	/*
	* ------------------------------------------------------------------------
	* Ripple Effect
	* Runs on any element with the ripple class
	* ------------------------------------------------------------------------
	*/
	rippleEffect: function() { 
		var createRippleEffect = function(event) {
			
			// Get current button
			const button = event.currentTarget;  

			// Get position of x where mouse was clicked 
			let positionX = this.offsetLeft;
  
			// Get position of y where mouse was clicked 
			let positionY = this.offsetTop;

			// Get button width
			let buttonWidth = this.offsetWidth;

			// Get button height
			let buttonHeight = this.offsetHeight;

			// Add the ripple element 
			let ripple = document.createElement("span");
  
			// Append span element to button
			this.appendChild(ripple);

			// Shape the ripple effect
			if (buttonWidth >= buttonHeight) {
				buttonHeight = buttonWidth;
			} else {
				buttonWidth = buttonHeight; 
			}
 
		  // Get the center of the element
			var x = event.pageX - positionX - buttonWidth / 2;
			var y = event.pageY - positionY - buttonHeight / 2;

			// Create ripple size and position
			ripple.style.width = `${buttonWidth}px`;
			ripple.style.height = `${buttonHeight}px`;
			ripple.style.top = `${y}px`; 
			ripple.style.left = `${x}px`;

			// Add ripple class to element
			ripple.classList.add("ripple");
 
			// Remove ripple class to prevent spamming 
			setTimeout(() => { 
				if (ripple) {
					ripple.remove();
				}
			}, 1000);
		} 
 
		// Get button element
		const buttons = document.getElementsByTagName("button");  
 
		// Add ripple effect to all button elements  
		for (const button of buttons) {
			button.addEventListener("click", createRippleEffect);
		}   

		// Get elements with ripple effect class
		const ripples = document.getElementsByClassName('ripple-effect');

		// Add ripple effect to all elements with ripple effect class  
		for (const ripple of ripples) {
			ripple.addEventListener("click", createRippleEffect);
		}    
	},

	/* 
	* ------------------------------------------------------------------------
	* Scroller Effect
	* Runs on any element with the animsta class to create scroll animation 
	* ------------------------------------------------------------------------
	*/
	scrollama: function() { 
		if(document.querySelector('.animista')) {
			var scroller = scrollama();

			scroller
				.setup({
					step: '.animista',
					offset: 0.85 // Move trigger threshold  
				})
				// Add appear class to all animista wrapper elements
				.onStepEnter(function(response) {
					response.element.classList.add('appear');
				});
	
			window.addEventListener('resize', scroller.resize);
		} 
	},  

 	/*
	* ------------------------------------------------------------------------
	* Show Current Page Status
	* Runs to show current page status when clicked
	* ------------------------------------------------------------------------
	*/  
	showCurrentPageStatus: function () {
		let url = window.location.href; 
		var menuNavLinks = document.querySelectorAll('.main-navbar .nav-item a');

		// Add current class if menu name matches current page name
		for (let i = 0; i < menuNavLinks.length; i++) {
			if (menuNavLinks[i].href === url) {
				menuNavLinks[i].classList.add('current');
			}
		}  

		// Add current class to menu name for one page themes
		menuNavLinks.forEach((element, index)=> {  
			element.addEventListener('click', (event)=> {
				// console.log('event: ', event);  
				selectItem(element);
			});
		});
 
		//*** Select Item ***//
		function selectItem(item) {
			// Refresh style state
			if(item.classList.contains('current', 'active')) {
				item.classList.remove('current', 'active', 'text-white') 
			}  
			// Remove other selected items
			document.querySelectorAll('.current').forEach(e => e.classList.remove('current', 'active', 'text-white'));
	 		// Add selected class to current item
	 		item.classList.add('current', 'active', 'text-white');     
		} 
	}, 

	/*
	* ------------------------------------------------------------------------
	* Sidebar Nav Progress
	* Runs fixed on the left side and above tablet viewport
	* ------------------------------------------------------------------------
	*/ 
	sidebarNavProgress: function () {    
		if(document.querySelector('.animate-sidebar-trigger')) { 
			
			// reset nav section colors
			const resetNavSectionColors = ["white"]; 
		
			// get gsap fire containers into an array
			const triggerSections = gsap.utils.toArray(".animate-sidebar-trigger");  

			// get sidenav links into an array
			const sidebarNavlinks = gsap.utils.toArray(".sidebar-navlink");   

			// get sidebar icons into an array		
			const sidebarIcons = gsap.utils.toArray(".pfs-progress-nav");
		
			gsap.set(sidebarNavlinks, {
				backgroundColor: gsap.utils.wrap(resetNavSectionColors)
			})  

			// create scroll trigger for side nav effects
			triggerSections.forEach(function(section, index) { 
	
				ScrollTrigger.create({
					trigger: section, // when scroll reaches the trigger section
					start: "top center",
					end: "bottom center",
					markers: false, 
					onEnter() {
						sidebarNavlinks[index].classList.add('active');
						sidebarIcons[index].classList.add('active');
					},
					onLeave() {
						// sidebarNavlinks[index].classList.remove('active');
						// sidebarIcons[index].classList.remove('active'); 
					},
					onEnterBack() {
						sidebarNavlinks[index].classList.add('active');
						sidebarIcons[index].classList.add('active');
					},
					onLeaveBack() {
						sidebarNavlinks[index].classList.remove('active');
						sidebarIcons[index].classList.remove('active');
					} 
				}); 
			});   
		}
	}, 

	/* 
	* ------------------------------------------------------------------------
	* Toggle Menu  
	* Runs on the main nav menu toggler
	* ------------------------------------------------------------------------
	*/ 
	toggleMenu: function () {    
		var navBar = document.querySelector('#navbar-menu');
		var toggleMenu = document.querySelector('#toggle-menu'); 
		var line1 = document.getElementById("a");
		var line2 = document.getElementById("b");
		var line3 = document.getElementById("c"); 
		
		toggleMenu.addEventListener('click', function() {
			line1.classList.toggle('a');
			line2.classList.toggle('c');
			line3.classList.toggle('b'); 
		}); 

		// collapse menu when clicked outside
		window.onclick = function (event) { 
			if (!event.target.matches('.navbar-toggler')) {
				if (navBar.classList.contains('show')) {
					navBar.classList.remove('show');
					toggleMenu.classList.toggle('collapsed');

					line1.classList.toggle('a');
					line2.classList.toggle('c');
					line3.classList.toggle('b'); 
				}
			}
		};
	},    

	/*
	* ------------------------------------------------------------------------
	* Triforce AJAX Loader Animated
	* Creates a triforce loader for forms
	* ------------------------------------------------------------------------
	*/  
	triforceAjaxLoader: function () {
		if(document.querySelector('.triangle1')) { 
			let triangle1 = {
				targets: '.triangle1',
				background: '#eee',
				opacity: 0.9,
				duration: 100,
			};

			let triangle2 = {
				targets: '.triangle2',
				background: '#eee',
				opacity: 0.9,
				duration: 150,
			};

			let triangle3 = {
				targets: '.triangle3',
				background: '#eee',
				opacity: 0.9,
				duration: 150,
			};

			let resetTriangle1 = {
				targets: '.triangle1',
				background: '#FFBC00',
				opacity: 1,
				duration: 200,
				delay: 300,
			};

			let resetTriangle2 = {
				targets: '.triangle2',
				background: '#FFBC00',
				opacity: 1,
				duration: 200,
				offset: '-=200',
			};

			let resetTriangle3 = {
				targets: '.triangle3',
				background: '#FFBC00',
				opacity: 1,
				duration: 200,
				offset: '-=1000',
			};

			let spin = {
				targets: '.triforce-ajax-loader',
				duration: 150,
				easing: 'easeInOutQuad',
				rotate: '1turn',
			};

			const animeTriforce = anime.timeline({
				delay: 150,
				loop: true,
			});

			animeTriforce.add(triangle1).add(triangle2).add(triangle3).add(resetTriangle1).add(resetTriangle2).add(resetTriangle3).add(spin);

			animeTriforce.play();

		}
	}, 

	/*
	* ------------------------------------------------------------------------
	* WooCommerce
	* Runs functions for e-Commerce  
	* ------------------------------------------------------------------------
	*/ 
	wooCommerce: function () {  
		// Style add-to-cart buttons
		if (document.querySelector('.woocommerce')) {
			// Add to cart button
			let cartBtn = document.querySelectorAll('.woocommerce a.button.add_to_cart_button');   

			// Add to cart button
			cartBtn.forEach((item)=> {
				let btnSpan = document.createElement('span'); 
				let btnIcon = document.createElement('i');

				// Add class 
				item.classList.add('pfs-btn', 'btn-hover-border', 'btn-effects', 'btn');
				item.innerHTML = '';

				// Add icon
				item.appendChild(btnIcon);
				btnIcon.classList.add('pfs-icon', 'fa-duotone', 'fa-angles-right');
				
				// Add text
				item.appendChild(btnSpan);
				btnSpan.classList.add('btn-text');
				btnSpan.innerHTML = 'See More';  
			});     
			
			// Select variable options button
			let variableBtn = document.querySelectorAll('.woocommerce a.button.product_type_variable');  

			// Add to cart variable button
			variableBtn.forEach((item)=> {
				let btnSpan = document.createElement('span'); 
				let btnIcon = document.createElement('i');

				// Add class and ID 
				item.classList.add('pfs-btn', 'btn-hover-border', 'btn-effects', 'btn');
				item.innerHTML = '';

				// Add icon
				item.appendChild(btnIcon);
				btnIcon.classList.add('pfs-icon', 'fa-duotone', 'fa-angles-right');
				
				// Add text
				item.appendChild(btnSpan);
				btnSpan.classList.add('btn-text');
				btnSpan.innerHTML = 'See Options';  
			});     
		}

		// Single Product Page
		if (document.getElementById('single-post-meta')) {
			let parentContainer = document.querySelector('.container');
			parentContainer.classList.add('woocommerce', 'woocommerce-single-product');
		}

		// Cart Page
		if (document.querySelector('.woocommerce-notices-wrapper')) { 
			let parentContainer = document.querySelector('.container'); 
			parentContainer.classList.add('a-woocommerce-cart-page');  
		} 
	}, 

	/*
	* ------------------------------------------------------------------------
	* Contact Form Button
	* Adds right arrow to the form buttons
	* ------------------------------------------------------------------------
	*/ 
	contactFormBtn: function () {  
		if (document.querySelectorAll('.pfs-general-form-btn')) {
 
			let contactFormBtn = document.querySelectorAll('.pfs-general-form-btn');
			let formBtnCounter = 0; 

			// Add right arrow
			contactFormBtn.forEach((item)=> {  
				let btnSpan = document.createElement('span'); 
				let btnIcon = document.createElement('i'); 

				// Add class and ID
				item.id = 'general-form-btn-' + formBtnCounter++;   
				// item.classList.add('pfs-btn', 'btn-hover-border', 'btn-effects', 'btn');  
				// item.innerHTML = '';

				// Add icon  
				btnIcon.classList.add('pfs-general-form-icon', 'fa-duotone', 'fa-angles-right', 'text-white');  
				// Add text
				btnSpan.classList.add('btn-text');
				// btnSpan.innerHTML = 'Sign Up Now';  

				item.appendChild(btnIcon); 
				item.appendChild(btnSpan);  
			});    
		}  
	},  
	
	// ANIME HERO
	animeHeroEffect: function () {
		let line1 = anime({
			targets: '.anime-hero-title .line1',
			duration: 500,
			translateX: '-300px',
			easing: 'easeInOutQuad',
			opacity: 1,
		});

		let line2 = anime({
			targets: '.anime-hero-title .line2',
			duration: 500,
			translateX: '330px',
			easing: 'easeInOutQuad',
			offset: '-=500',
			opacity: 1,
		});

		let letters = anime({
			duration: 2000,
			targets: '.anime-hero-title .letters',
		});

		const animeTitle = anime.timeline({
			delay: 1000,
			loop: false,
		});

		animeTitle.add(line1).add(line2).add(letters);

		animeTitle.play();
	}, 

 	// ANIME TITLE
	 animeTitleEffect: function () {
		anime({
			targets: '.line1',
			duration: 500,
			opacity: 0.5,
			translateX: '-110px',
			easing: 'easeInOutQuad',
		});

		anime({
			targets: '.line2',
			duration: 500,
			opacity: 0.5,
			translateX: '140px',
			easing: 'easeInOutQuad',
			offset: '-=500',
		});

		anime({
			duration: 2000,
			targets: '.letters',
			opacity: 1,
		});
	}, 

	// JUMP TO HASHTAG LINK
	jumpToHashTagLink: function () { 
	
		// Regular expression to check if string is a hashtag
		const regexExp = /^#[^ !@#$%^&*(),.?":{}|<>]*$/gi;

		// Array menu items
		var menuItems = document.querySelectorAll('.navbar-nav .menu-item'); 

		// Counter
		let counter = 1; 

		// Array all nav-links
		var navItems = document.querySelectorAll('.nav-link'); 
	
		// Add ID #s to nav-links 
		navItems.forEach((element)=> {
			element.id = 'nav-link-' + `${counter}`;
			counter++;  
		});  

		menuItems.forEach((navBtn)=> {
			navBtn.addEventListener('click', ()=> {

				if (regexExp.test(navBtn.querySelector('a').getAttribute('href'))) {

					jump(navBtn.querySelector('a').getAttribute('href'));
					console.log(":: Jump Successful ::");
				}

			});
		});
	
		function jump(h){
			var url = location.href;               //Save down the URL without hash.
			location.href = h;                 //Go to the target element.
			history.replaceState(null,null,url);   //Don't like hashes. Changing it back.
			console.log(":: JUMPING ::");
		}
	},  

	// RELLAX SECTION PARALLAX
	rellaxSection: function () { 
		if (navigator.userAgent.match(/Android/i) || navigator.userAgent.match(/webOS/i) || navigator.userAgent.match(/iPhone/i) || navigator.userAgent.match(/iPod/i) || navigator.userAgent.match(/BlackBerry/i) || navigator.userAgent.match(/Windows Phone/i)) {
			// call empty function
			const empty = () => void 0; 
		} else {    
			window.onload = function () { 
				// var rellax = new Rellax('.rellax-section', { 	
				// 	center: true, 
				// }); 

				//*** Front Page ***// 
				if (document.querySelector('.front-page')) { 
					// var rellaxTeam = new Rellax('.rellax-roadmap', { 	
					// 	center: true, 
					// }); 
					// var rellaxPerks = new Rellax('.rellax-perks', { 	
					// 	center: true, 
					// }); 
					// var rellaxTeam = new Rellax('.rellax-team', { 	
					// 	center: true, 
					// });  
					// var rellaxRarity = new Rellax('.rellax-rarity', { 	
					// 	center: true, 
					// });  
					// var rellaxFAQ = new Rellax('.rellax-faq', { 	
					// 	center: true, 
					// }); 
				}
			};   
		}
	},  
}
 
// initialize functions on window load
e.init();

// TEST FOR SUCCESS
if (process.env.NODE_ENV !== 'production') {
	console.log('Development mode: Index Script Working');
}  

// /// 04 ONCLICK BUTTON SCROLL TO EFFECT
// onclickScrollEffect: function () {
// 	document.getElementsByClassName("scroll").forEach((trigger) => {
// 		trigger.onclick = function (e) {
// 			// Do not run if function doesn't fire
// 			e.preventDefault();

// 			// Save targeted attribute
// 			let hash = this.getAttribute("href");

// 			// Return elements with targeted attribute
// 			let target = document.querySelector(hash);

// 			// Positioning of viewport
// 			let headerOffset = 100;

// 			// Returns the distance of the outer border of the current element
// 			// relative to the inner border of the top of the offsetParent node
// 			let elementPosition = target.offsetTop;

// 			// Targeted position
// 			let offsetPosition = elementPosition - headerOffset;

// 			window.scrollTo({
// 				top: offsetPosition,
// 				behavior: "smooth",
// 			});
// 		};
// 	});
// },
 